export const StringUtils = {
    isEmpty
}

function isEmpty(str: string | null | undefined) {
    return (!str || str.length === 0);
}